import React from 'react';
import { Typography, Box, Paper } from '@mui/material';

const ExpressionPreview = ({ expression }) => {
    console.log("ExpressionPreview props:", expression);
    if (!expression || !Array.isArray(expression) || expression.length === 0) {
        return (
            <Paper elevation={3} sx={{ 
                p: 2, 
                display: 'flex',
                flexDirection: 'column',
                height: 'auto',
                minHeight: '200px'
            }}>
                <Typography variant="h6" align="center" sx={{ mb: 2 }}>Expression Flowchart Preview</Typography>
                <Box sx={{ mt: 2 }}>
                    <Typography align="center">No expression data available.</Typography>
                </Box>
            </Paper>
        );
    }

    const renderOperator = (operator, index, total) => (
        <Box 
            key={operator._id} 
            mb={2} 
            sx={{ 
                border: '1px solid rgba(0, 0, 0, 0.12)',
                borderRadius: '4px',
                padding: 2,
                backgroundColor: 'rgba(0, 0, 0, 0.02)'
            }}
        >
            <Typography variant="h6" align="center" sx={{ mb: 1 }}>{operator.name}</Typography>
            {operator.factors.map(factor => (
                <Box key={factor.id} ml={2} my={1}>
                    <Typography variant="subtitle2" align="center" sx={{ fontWeight: 'bold' }}>
                        <b>{factor.label}</b> {factor.value && `(Score: ${factor.value})`}
                    </Typography>
                    {factor.items_included.map(itemId => {
                        const item = operator.items[itemId];
                        const formattedText = operator.prompt_templates.item_format
                            .replace("{item_id}", itemId)
                            .replace("{text}", item.text);
                        return (
                            <Typography variant="body2" key={itemId} ml={2} align="center">
                                {formattedText}
                            </Typography>
                        );
                    })}
                </Box>
            ))}
            {index < total - 1 && (
                <Typography variant="body2" align="center" sx={{ mt: 1 }}>↓</Typography>
            )}
        </Box>
    );

    return (
        <Paper elevation={3} sx={{ 
            p: 2, 
            display: 'flex',
            flexDirection: 'column',
            height: 'auto',
            minHeight: expression && expression.length ? 'auto' : '200px'
        }}>
            <Typography variant="h6" align="center" sx={{ mb: 2 }}>Expression Flowchart Preview</Typography>
            <Box 
                sx={{ 
                    mt: 1, 
                    maxHeight: '70vh',
                    overflowY: 'auto',
                    overflowX: 'hidden',
                    pr: 1,
                    '&::-webkit-scrollbar': {
                        width: '8px',
                    },
                    '&::-webkit-scrollbar-track': {
                        backgroundColor: 'rgba(0, 0, 0, 0.05)',
                    },
                    '&::-webkit-scrollbar-thumb': {
                        backgroundColor: 'rgba(0, 0, 0, 0.2)',
                        borderRadius: '4px',
                    }
                }}
            >
                {expression.map((operator, index) => renderOperator(operator, index, expression.length))}
            </Box>
        </Paper>
    );
};

export default ExpressionPreview;
